/**
 * Relays WooCommerce's jQuery events as DOM CustomEvents so theme modules can
 * stay jQuery-free. Loaded as a classic script after wc-cart-fragments.
 *
 *   added_to_cart          -> tc:cart:added    (detail: { fragments, cartHash })
 *   removed_from_cart      -> tc:cart:changed
 *   wc_fragments_refreshed -> tc:cart:refreshed
 *   wc_fragments_loaded    -> tc:cart:refreshed
 *   found_variation        -> tc:variation     (detail: variation)  [used by the gallery, build step 3]
 *   reset_data             -> tc:variation     (detail: null)
 */
(function ($) {
  if (!$) return;
  var emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  };
  var $body = $(document.body);

  $body.on('added_to_cart', function (e, fragments, cartHash) {
    emit('tc:cart:added', { fragments: fragments, cartHash: cartHash });
  });
  $body.on('removed_from_cart', function (e, fragments, cartHash) {
    emit('tc:cart:changed', { fragments: fragments, cartHash: cartHash });
  });
  $body.on('wc_fragments_refreshed wc_fragments_loaded', function () {
    emit('tc:cart:refreshed', null);
  });
  $(document).on('found_variation', 'form.variations_form', function (e, variation) {
    emit('tc:variation', variation);
  });
  $(document).on('reset_data', 'form.variations_form', function () {
    emit('tc:variation', null);
  });
})(window.jQuery);
